import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { SuketSehatJasmaniInterface } from "@/types/suket_sehat_jasmani";
import SvcSuketSehatJasmani from "@/services/SuketSehatJasmani";
import { storePasien } from "@/store/modules/pasien";

@Module({ dynamic: true, namespaced: true, store, name: "suket-sehat-jasmani" })
class SuketSehatJasmani extends VuexModule {
  suket: Array<SuketSehatJasmaniInterface> = [];
  loading = false;

  get pasien(): any {
    return storePasien.identitasPasien;
  }

  @Mutation
  SET_SUKET(suket: Array<SuketSehatJasmaniInterface>) {
    this.suket = suket;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action({ rawError: true })
  async fetchSuketByRegister(): Promise<void> {
    this.SET_LOADING(true);

    const suketArray = await SvcSuketSehatJasmani.getByRegister(
      this.pasien.register.no
    ).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_SUKET(suketArray.data ? suketArray.data : []);
  }

  @Action({ rawError: true })
  async getSuketByRegister(noReg): Promise<void> {
    this.SET_LOADING(true);

    const suketArray = await SvcSuketSehatJasmani.getByRegister(noReg).finally(
      () => {
        this.context.commit("SET_LOADING", false);
      }
    );

    this.SET_SUKET(suketArray.data ? suketArray.data : []);
  }
}

export default getModule(SuketSehatJasmani);
